import React, { useState, useEffect, useRef } from "react";
import BackButton from "../../components/BackButton/BackButton";
import Button from "../../components/Button/Button";
import Dropdown from "../../components/Dropdown/Dropdown";
import Map from "../../components/Map/Map";
import "leaflet/dist/leaflet.css";
import axios from "axios";
import "./styles.css";

function SendInfo({ onBack, onContinue, userLocation }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [homeToggle, setHomeToggle] = useState(false);
  const [selectedSede, setSelectedSede] = useState(null);
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [addressComplement, setAddressComplement] = useState("");
  const [email, setEmail] = useState("");

  const [isLocalButtonEnabled, setIsLocalButtonEnabled] = useState(false);
  const [isHomeButtonEnabled, setIsHomeButtonEnabled] = useState(false);

  const buttonRef = useRef(null); 

  useEffect(() => {
    axios
      .get(`https://api.quieromac.com/agendas/stores`)
      .then((response) => {
        const result = response.data.data;
        setData(result);
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
      });
  }, []);

  const handleDropdownSelect = (item) => {
    setSelectedSede(item);
    if (item) {
      setIsLocalButtonEnabled(true);
    }
  };

  useEffect(() => {
    if (selectedSede) {
        if (buttonRef.current) {
          buttonRef.current.scrollIntoView({ behavior: "smooth" });

        }
    }
  }, [selectedSede]);

  useEffect(() => {
    if (
      homeToggle &&
      address.trim() !== "" &&
      email.trim() !== "" &&
      phone.trim() !== ""
    ) {
      setIsHomeButtonEnabled(true);
    } else {
      setIsHomeButtonEnabled(false);
    }
  }, [homeToggle, address, addressComplement, email, phone]);

  const handleContinueClick = () => {
    const info = {
      selectedSede: selectedSede,
      address: address,
      addressComplement: addressComplement,
      email: email,
      phone: phone,
      localOption: isLocalButtonEnabled,
      homeOption: isHomeButtonEnabled,
    };
    onContinue(info);
  };

  return (
    <div>
      <h1>Elige el local más cercano</h1>
      <div className="sendOptions">
        <div className="sendInfoContainer">
          <div>
            <p className="description">
              Tenemos varias tiendas en la ciudad. Selecciona la más cercana a
              tu ubicación{" "}
              <span>para agendar una cita con nuestro asesor,</span> quien
              verificará el estado de tu dispositivo y te ayudará en el proceso.
            </p>
            <Dropdown
              placeholder="Seleccionar"
              list={data}
              onSelect={handleDropdownSelect}
            />
            {selectedSede?.location ? (
              <Map address={selectedSede.location} />
            ) : (
              <Map userLocation={userLocation} />
            )}
            <div className="space" ref={buttonRef}/>
            <Button
              type={isLocalButtonEnabled ? "black" : "disabled"}
              onClick={handleContinueClick}
            >
              Continuar
            </Button>
          </div>
        </div>
      </div>
      <BackButton onClick={onBack} />
    </div>
  );
}

export default SendInfo;
